import { HttpErrorResponse } from '@angular/common/http';

export interface ErrorModalVisuals {
  icon: string;
  subtitle: string;
}

export function extractApiErrorMessage(err: unknown, fallback: string): string {
  if (err == null) {
    return fallback;
  }

  if (err instanceof HttpErrorResponse) {
    const fromBody = messageFromBody(err.error);
    if (fromBody) {
      return fromBody;
    }
  }

  const record = err as { error?: unknown; message?: string };
  const fromNested = messageFromBody(record.error);
  if (fromNested) {
    return fromNested;
  }

  const message = (record.message || '').trim();
  if (message && !message.toLowerCase().startsWith('http failure')) {
    return message;
  }

  return fallback;
}

export function resolveErrorModalVisuals(message: string): ErrorModalVisuals {
  const lower = (message || '').toLowerCase();

  if (
    lower.includes('connection refused') ||
    lower.includes('failed host lookup') ||
    lower.includes('network') ||
    lower.includes('connexion') ||
    lower.includes('internet') ||
    lower.includes('502') ||
    lower.includes('503')
  ) {
    return { icon: 'wifi_off', subtitle: 'Problème de connexion' };
  }

  if (lower.includes('timeout') || lower.includes('délai') || lower.includes('delai')) {
    return { icon: 'schedule', subtitle: 'Délai dépassé' };
  }

  if (
    lower.includes('401') ||
    lower.includes('403') ||
    lower.includes('unauthorized') ||
    lower.includes('session') ||
    lower.includes('reconnect') ||
    lower.includes('accès') ||
    lower.includes('acces')
  ) {
    return { icon: 'lock', subtitle: 'Accès refusé' };
  }

  if (lower.includes('404') || lower.includes('introuvable')) {
    return { icon: 'search_off', subtitle: 'Ressource introuvable' };
  }

  return { icon: 'error_outline', subtitle: 'Une erreur est survenue' };
}

function messageFromBody(body: unknown): string {
  if (body == null) {
    return '';
  }

  if (typeof body === 'string') {
    const trimmed = body.trim();
    if (!trimmed) {
      return '';
    }
    try {
      return messageFromBody(JSON.parse(trimmed));
    } catch {
      return trimmed;
    }
  }

  if (typeof body === 'object') {
    const record = body as Record<string, unknown>;
    const candidate = record['errorMessage'] ?? record['message'];
    if (candidate != null && String(candidate).trim()) {
      return String(candidate).trim();
    }
  }

  return '';
}
